module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8477/img/cta-blobs.png"